import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../../service-call-utils.service';
import { constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ComboWizardService {
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }


  /**
   * Description: Método que llama el servicio web de obtener saldo de una línea
   * Autor: Diego Diaz
   * @param phone número a consultar saldo
   * @return saldo
   */
  getBalance(phone) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_BALANCE, { "subscriptionId": phone });
  }



  /**
   * Description: Method that calls the web service that returns whether or not there is a recurrence combo with the number
   * Autor: Luis Hernandez
   * @param phone número a consultar
   * @return boolean
   */
  getFindSubscription(line) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_SUBSCRIPTION, { "contractIdentifier": line });
  }




  /**
   * Description: Method that calls the web service that returns the recurring payment form
   * Autor: Luis Hernandez
   * @param 
   * @return
   */
  getRecurrenceForm(data) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_RECURRENCEFORM, data);
  }


  /**
 * Description: Método que llama el servicio web de obtener listado de tarjetas de credito guardadas
 * Autor: Diego Diaz
 * @param documentId identificación
 * @return Listado de tarjetas
 */
  getStoredCards(documentId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RECHARGE_STORED_CARDS, { "identification": documentId });
  }

  /**
 * Description: Método que llama el servicio web de eliminar tarjetas de credito guardadas
 * Autor: Diego Diaz
 * @param id identificador de la tarjeta
 * @return Confirmación de la eliminación
 */
  deleteStoredCards(id) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RECHARGE_DELETE_STORED_CARDS, { "id": id, "paymentParam": constants.PAYMENT_FORM_REST_RECHARGE });
  }

  /**
   * Description: Método que llama el servicio web de obtener formulario de pagos
   * Autor: Diego Diaz
   * @param jsonData parámetros de entrada del servicio
   * @return Formulario de pagos
   */
  getPaymentForm(jsonData) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_RECHARGE_GET_FORM, jsonData);
  }

  /**
 * Description: Método que llama el servicio de validar si un teléfono esta dentro de la marca
 * Autor: Diego Diaz
 * @param phone teléfono a validar
 * @return confirmación de la validación
 */
  validatePhoneInBrand(phone) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_VALIDATE_PHONE_IN_BRAND, { "msisdn": phone });
  }


  /**
 * Description: Método que llama el servicio de comprar combo o bono con el saldo disponible
 * @param dataJson parametros de entrada del servicio
 * @return Confirmación de compra
 */
  contractPackageTopupBalance(dataJson) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_COMBOS_CONTRACT_TOPUP_BALANCE, dataJson);
  }


  /**
   * Description: Método que llama el servicio web de obtener sla configuracion de recurrencia, si es encendido o apagado
   * Autor: Diego Diaz
   * @param N/A
   * @return Swtich true(encendido) o false(apagado)
   */
  getRecurrenceEnableConfig() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_SWITCH_RECURRENCE_CONFIG, "");
  }
  /**
* Description: Método que llama el servicio para gestionar el Cancel
* Autor: Fernando Herdoiza
* @param idTable identificador del registro de la base de datos
*/
  startCancelAsync(idTable) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_PAYMENT_CANCEL_ASYNC, { "idTable": idTable });
  }


}
